<template>
  <div class="flex justify-between items-center text-lg font-medium">
    <h2>
      {{ trans.get('miliboo.header.search.products') }} ({{ count }})
    </h2>
    <a
      class="flex items-center gap-2 underline"
      :href="`/search?query=${encodeURIComponent(term)}`"
    >
      {{ trans.get('miliboo.header.search.see-more') }} <v-icon-chevron-r class="size-4" />
    </a>
  </div>
  <ol
    class="grid grid-cols-1 md:grid-cols-2 gap-4"
    role="list"
  >
    <template v-if="products.length">
      <li
        v-for="product in products"
        :key="product.id"
      >
        <SuggestProductListItem :product="product" />
      </li>
    </template>
    <SuggestProductListEmpty v-else />
  </ol>
</template>
<script setup>
import { inject } from 'vue';
import SuggestProductListItem from './SuggestProductListItem.vue';
import SuggestProductListEmpty from './SuggestProductListEmpty.vue';

const trans = inject('translate');

defineProps({
  products: {
    type: Array,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  term: {
    type: String,
    required: true,
  },
});
</script>
